$('.otazka').on('click', function() {
  $(this).toggleClass('active');
});